import { useState, useEffect } from "react";
import { BaseDialog } from "@/components/common/base-dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { InputField } from "@/components/common";

interface NameProjectDialogProps {
  open: boolean;
  currentName: string;
  onConfirm: (name: string) => void;
  onClose: () => void;
}

export const NameProjectDialog = ({
  open,
  currentName,
  onConfirm,
  onClose,
}: NameProjectDialogProps) => {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    if (open) setName(currentName);
  }, [open, currentName]);

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed) onConfirm(trimmed);
  };

  return (
    <BaseDialog open={open} onOpenChange={(v) => !v && onClose()} title="프로젝트명">
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-[#000000]">프로젝트 이름</label>
        <Input
          value={name}
          onChange={(e) => {
            setName(e.target.value.slice(0, 100));
          }}
          placeholder="프로젝트 이름..."
          className="h-12"
        />
      </div>

      <div className="flex justify-end">
        <Button
          onClick={handleConfirm}
          disabled={!name.trim()}
          className="w-full h-12 rounded bg-[#FFAA72] text-base font-bold text-black "
        >
          OK
        </Button>
      </div>
    </BaseDialog>
  );
};
